var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12" },
    [
      _vm._m(0),
      _c("div", { staticClass: "row m-0" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _c(
            "ul",
            { staticClass: "crumb-trail" },
            _vm._l(_vm.cases, function (case_item, index) {
              return _c(
                "li",
                {
                  key: index,
                  staticClass: "col-md-3 col-sm-3 col-lg-3 p-0",
                  class: {
                    "is-active-slide col-xs-6":
                      _vm.current_slide_number === index,
                    "col-xs-2": _vm.current_slide_number !== index,
                    completed_slide: _vm.current_slide_number > index,
                  },
                },
                [
                  _c("div", { staticClass: "crumb" }, [
                    _c("img", {
                      staticClass: "breadcrumb-img",
                      attrs: {
                        src: "/static/images/icons/circle_check.svg",
                        alt: "check-icon",
                      },
                    }),
                    _c("span", [_vm._v(_vm._s(case_item.title))]),
                  ]),
                ]
              )
            }),
            0
          ),
        ]),
      ]),
      _vm._l(_vm.cases, function (case_item, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "row",
            class: { "is-active-slide": _vm.current_slide_number === index },
          },
          [
            case_item.title === "Select Services"
              ? _c(
                  "div",
                  { staticClass: "col-md-12 main-content" },
                  [
                    _c("select-service-upgrade", {
                      ref: "selectService",
                      refInFor: true,
                      attrs: {
                        serviceSelected: _vm.serviceSelected,
                        currentService: _vm.currentService,
                        selectedRecords: _vm.selectedRecords,
                        teamMemberData: _vm.selectedTeamData,
                        teamMemberProRata: _vm.teamMemberProRata,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            case_item.title === "Payment Method"
              ? _c(
                  "div",
                  { staticClass: "col-lg-12 col-md-12 col-sm-12 main-content" },
                  [
                    _c("payment-method", {
                      attrs: {
                        paymentOptionsList: _vm.paymentOptionsList,
                        totalPrice: _vm.totalPrice,
                      },
                      on: { uID: _vm.uID, paymentOpts: _vm.paymentOptions },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            case_item.title === "Billing info"
              ? _c(
                  "div",
                  { staticClass: "col-lg-12 col-md-12 col-sm-12 main-content" },
                  [
                    _c("billing-info", {
                      ref: "billingInfo",
                      refInFor: true,
                      attrs: {
                        purchaseOrder: _vm.payment_option == 2,
                        current_slide: _vm.current_slide_number,
                        billingData: _vm.billingData,
                      },
                      on: { saveBillingInfo: _vm.saveBillingInfo },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            case_item.title === "Confirmation"
              ? _c(
                  "div",
                  { staticClass: "col-lg-12 col-md-12 col-sm-12 main-content" },
                  [
                    _c("confirmation-tab", {
                      attrs: {
                        serviceId: _vm.serviceId,
                        selectedRecords: _vm.selectedRecords,
                        selectedRecordsProdCls: _vm.selectedRecordsProdCls,
                        selectedRecordsProdClsRat:
                          _vm.selectedRecordsProdClsRat,
                        selectedRecordsRegPathwy: _vm.selectedRecordsRegPathwy,
                        serviceSelected: _vm.serviceSelected,
                        teamMemberData: _vm.selectedTeamData,
                        paymentSelected: _vm.paymentSelected,
                        billingDetails: _vm.billingDetails,
                        serviceMarket: _vm.serviceMarket,
                        serviceCountry: _vm.serviceCountry,
                        serviceCountries: _vm.serviceCountries,
                        regIntelPrice: _vm.regIntelPrice,
                        bundleDetails: _vm.bundleDetails,
                        defaultCountry: _vm.defaultCountry,
                        paymentStatus: _vm.paymentStatus,
                        totalPrice: _vm.totalPrice,
                        proRataData: _vm.proRataData,
                        teamMemberProRata: _vm.teamMemberProRata,
                        purchaseType: "upgrade",
                      },
                      on: { editSlide: _vm.navigateToSlide },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]
        )
      }),
      _c("div", { staticClass: "row case-slider__navigation m-0" }, [
        _vm.current_slide_number != 0 &&
        !_vm.paymentStatus &&
        _vm.payment_option !== 1
          ? _c(
              "div",
              { staticClass: "prev col-lg-2 col-md-2 col-sm-2 col-xs-4" },
              [
                _c(
                  "button",
                  {
                    staticClass: "custom-padding emergo-blue-button",
                    on: { click: _vm.prevSlide },
                  },
                  [_vm._v("Back")]
                ),
              ]
            )
          : _vm._e(),
        !_vm.paymentStatus && _vm.payment_option !== 1
          ? _c(
              "div",
              {
                staticClass: "cancel col-lg-2 col-md-2 col-sm-2",
                class: {
                  "col-xs-4 col-md-offset-7 col-lg-offset-8 col-sm-offset-7 cancel_first_slide":
                    _vm.current_slide_number == 0,
                  "col-sm-offset-5 col-md-offset-5 col-lg-offset-6 cancel_other_slide hide-first-cancel":
                    _vm.current_slide_number != 0,
                },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "custom-padding emergo-white-button",
                    on: { click: _vm.showcancelModal },
                  },
                  [_vm._v("Cancel")]
                ),
              ]
            )
          : _vm._e(),
        _vm.cases.length - 1 == _vm.current_slide_number
          ? _c(
              "div",
              {
                staticClass: "next",
                class: {
                  "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right":
                    _vm.paymentStatus,
                  "col-xs-8 col-lg-2 col-md-3 col-sm-3": !_vm.paymentStatus,
                },
              },
              [
                _vm.payment_option !== 1
                  ? _c(
                      "button",
                      {
                        staticClass: "btn emergo-green-button btn-padding",
                        on: { click: _vm.confirmSubscription },
                      },
                      [_vm._v(" Confirm ")]
                    )
                  : _vm._e(),
                _vm.payment_option == 1
                  ? _c(
                      "button",
                      {
                        staticClass: "btn emergo-green-button btn-padding",
                        on: { click: _vm.confirmCC },
                      },
                      [_vm._v(" Confirm ")]
                    )
                  : _vm._e(),
              ]
            )
          : _vm._e(),
        _vm.current_slide_number === 0 && _vm.serviceSelected.id === 16
          ? _c(
              "div",
              {
                staticClass: "next",
                class: {
                  "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right":
                    _vm.payment_option == 1,
                  "col-xs-8 col-lg-2 col-md-3 col-sm-3":
                    _vm.payment_option !== 1,
                },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn emergo-green-button btn-padding",
                    on: { click: _vm.getProRata },
                  },
                  [_vm._v("Continue")]
                ),
              ]
            )
          : _vm.cases.length - 1 != _vm.current_slide_number
          ? _c(
              "div",
              {
                staticClass: "next",
                class: {
                  "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right":
                    _vm.payment_option == 1,
                  "col-xs-8 col-lg-2 col-md-3 col-sm-3":
                    _vm.payment_option !== 1,
                },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn emergo-green-button btn-padding",
                    on: { click: _vm.nextSlide },
                  },
                  [_vm._v("Continue")]
                ),
              ]
            )
          : _vm._e(),
        _c(
          "div",
          {
            staticClass: "hide-second-cancel cancel col-lg-2 col-md-2 col-sm-2",
            class: {
              "hide-first-cancel": _vm.current_slide_number == 0,
              "cancel_other_slide col-xs-12": _vm.current_slide_number != 0,
            },
          },
          [
            _c(
              "button",
              {
                staticClass: "emergo-white-button custom-padding",
                on: { click: _vm.showcancelModal },
              },
              [_vm._v("Cancel")]
            ),
          ]
        ),
        _c(
          "div",
          { staticClass: "modal fade", attrs: { id: "MymodalPreventScript" } },
          [
            _c("div", { staticClass: "modal-dialog" }, [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _vm._m(1),
                  _c("div", { staticClass: "card text-center" }, [
                    _vm._m(2),
                    _c("div", { staticClass: "row card-footer" }, [
                      _c("div", { staticClass: "col-sm-6 pb_10" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-block emergo-white-button",
                            on: {
                              click: function ($event) {
                                return _vm.cancelled()
                              },
                            },
                          },
                          [_vm._v(" Leave Page ")]
                        ),
                      ]),
                      _vm._m(3),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]
        ),
      ]),
      _c("pro-rata-modal", {
        attrs: {
          proRataData: _vm.proRataData,
          serviceSelected: _vm.serviceSelected,
          selectedRecords: _vm.selectedRecords,
        },
        on: { nextSlide: _vm.nextSlide },
      }),
      _c("error-modal", { attrs: { errorMessage: _vm.errorMessage } }),
      _c("success-modal", {
        attrs: {
          showMessage: true,
          successMessage: _vm.successMessage,
          redirection: _vm.redirection,
          payment_option: _vm.payment_option,
          renew: "true",
        },
      }),
      _c("warn-modal", {
        attrs: { warnMessage: _vm.warnMessage, redirection: _vm.redirection },
      }),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 heading" },
        [_vm._v("Marketplace Purchase")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: { type: "button", "data-dismiss": "modal" },
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "card-title" }, [
        _c("p", { staticClass: "first-card-title" }, [
          _vm._v("Are you sure you would like"),
        ]),
        _c("p", { staticClass: "secnd-card-title" }, [
          _vm._v("to leave this page"),
        ]),
      ]),
      _c("div", { staticClass: "card-text" }, [
        _c("p", { staticClass: "first-card-text" }, [
          _vm._v("You have made changes to your purchases"),
        ]),
        _c("p", { staticClass: "scnd-card-text" }, [
          _vm._v("that will be lost if you decide to leave"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-sm-6" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-block emergo-blue-button",
          attrs: { "data-dismiss": "modal" },
        },
        [_vm._v(" Stay on Page ")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }